import { Component, Inject, OnDestroy } from '@angular/core';
import { AppNotification } from '../notification.model';
import { ApiRoot, ApiRootFacade } from '@schir-int-client/api-root';
import { filter, take } from 'rxjs/operators';
import { isNil } from 'lodash-es';
import { UserService } from '@schir-int-client/user-shared';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'schir-int-client-notification-alert',
	templateUrl: './notification-alert.component.html',
	styleUrls: ['./notification-alert.component.scss'],
	standalone: false,
})
export class NotificationAlertComponent implements OnDestroy {
	notification: AppNotification;
	apiRoot: ApiRoot;
	private subscription: Subscription;
	timestamp = new Date().toISOString();

	constructor(
		private dialogRef: MatDialogRef<NotificationAlertComponent>,
		@Inject(MAT_DIALOG_DATA) notification: AppNotification,
		private apiRootFacade: ApiRootFacade,
		private userService: UserService
	) {
		this.notification = notification;
		this.subscription = this.apiRootFacade
			.getCurrentApiRoot()
			.pipe(filter(apiRoot => !isNil(apiRoot)))
			.subscribe(apiRoot => {
				this.apiRoot = apiRoot;
			});
	}

	ok() {
		this.dialogRef.close();
	}

	copyAttachment() {
		this.userService
			.getUser()
			.pipe(take(1))
			.subscribe(async user => {
				const info = {
					id: this.notification.id,
					timestamp: new Date(),
					version: this.apiRoot?.version,
					ort: this.apiRoot?.ort,
					user: user.firstName + ' ' + user.lastName,
					message: this.notification.message,
				};

				const infoString = JSON.stringify(info, null, '\t');

				await this.copyToClipboard(infoString);
			});
	}

	async copyToClipboard(val: string) {
		try {
			await navigator.clipboard.writeText(val);
		} catch (err) {
			console.error('Failed to copy text to clipboard: ', err);
		}
	}

	get messageTokens(): string[] {
		return this.notification.message.split('\n');
	}

	get headline() {
		return this.notification.headline;
	}

	get attachment(): any {
		return this.notification.attachment;
	}

	get attachmentLabel(): string {
		return this.notification.attachmentLabel;
	}

	get errorId(): string {
		return this.notification.id;
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
